import { render, staticRenderFns } from "./devices-table.vue?vue&type=template&id=6c23bd70&scoped=true&"
import script from "./devices-table.vue?vue&type=script&lang=js&"
export * from "./devices-table.vue?vue&type=script&lang=js&"
import style0 from "./devices-table.vue?vue&type=style&index=0&id=6c23bd70&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c23bd70",
  null
  
)

export default component.exports